module.exports = __webpack_public_path__ + "assets/img/smile.d172acc7.svg";